export default __webpack_public_path__ + "static/media/todolist.efef3d04.PNG";